@if (html$ | async) {
  <div class="welcome-window">
    <mat-toolbar color="primary">
      <h1>{{ 'welcomeWindow.title' | translate }}</h1>
      <span class="spacer"></span>
      <label class="mat-body-2">
        <input
          id="doNotShowCheck"
          type="checkbox"
          [(ngModel)]="showAgain"
          (click)="setShowAgain()"
        />
        {{ 'welcomeWindow.notShowCheck' | translate }}
      </label>
    </mat-toolbar>
    <div mat-dialog-content class="text">
      <igo-custom-html [html]="html$ | async" />
    </div>
    <mat-dialog-actions class="button-container">
      <button
        mat-raised-button
        class="button-close"
        color="primary"
        mat-dialog-close
      >
        {{ 'welcomeWindow.closeButton' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
